import React from 'react';
import { func, string } from 'prop-types';

const ConfirmRequestModal = ({
  buttonClick,
  modalMessage = "Successfull",
  buttonText = 'Yes'
}) => {
  return (
    <div className="de__confmodal--body">
      <span >{modalMessage}</span>
      <div className="de__confmodal--actions">        
        <button
          type="button"
          onClick={buttonClick}
          className="de--btn de--btn__primary"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

ConfirmRequestModal.propTypes = {
    buttonClick: func,
    buttonText: string,
};

export default ConfirmRequestModal;
